import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { ExtensionHackedFraudDetails } from 'src/app/pages/extension-details/helpers/hacked-fraud-helper';
import { convertPhoneRegisterListItem } from '../../helpers/phones-helper';
import { PhoneRegisterResults } from '../../models/phone-register-results.model';
import { GetPhones } from '../../queries/generated/GetPhones';
import { PhoneRegisterApiService } from '../../services/phone-register-api.service';
import { phoneRegisterAdapterActions } from './phone-register.actions';
import { PhoneRegisterState, selectEndCursor } from './phone-register.reducer';

@Injectable()
export class PhoneRegisterEffects {
   loadPhoneList$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(phoneRegisterAdapterActions.pageEnter),
         switchMap(() => {
            return this.phoneRegisterApiService.getPhones(null, null, null).pipe(
               map((result) => {
                  return phoneRegisterAdapterActions.loadSuccess(
                     this.convertGetPhonesResultToLoadSuccessProps(result.data, null)
                  );
               }),
               catchError((error) => {
                  return of(phoneRegisterAdapterActions.loadFailure(error));
               })
            );
         })
      );
   });

   loadPhonePage$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(phoneRegisterAdapterActions.loadPage),
         withLatestFrom(this.store.pipe(select(selectEndCursor))),
         switchMap(([action, endCursor]) => {
            return this.phoneRegisterApiService.getPhones(endCursor, null, null).pipe(
               map((result) => {
                  return phoneRegisterAdapterActions.loadPageSuccess(
                     this.convertGetPhonesResultToLoadSuccessProps(result.data, null)
                  );
               }),
               catchError((error) => {
                  return of(phoneRegisterAdapterActions.loadPageFailure(error));
               })
            );
         })
      );
   });

   dialogId: string;

   constructor(
      private actions$: Actions,
      private store: Store<PhoneRegisterState>,
      private phoneRegisterApiService: PhoneRegisterApiService
   ) {}

   private convertGetPhonesResultToLoadSuccessProps(
      getPhones: GetPhones,
      hackedFraudDetails: ExtensionHackedFraudDetails | null
   ): PhoneRegisterResults {
      return {
         endCursor: getPhones.phonesConnection.pageInfo.endCursor,
         hasNextPage: getPhones.phonesConnection.pageInfo.hasNextPage,
         items: getPhones.phonesConnection.items.map((getPhoneItem) =>
            convertPhoneRegisterListItem(getPhoneItem, hackedFraudDetails)
         ),
         totalCount: getPhones.phonesConnection.totalCount,
      };
   }
}
